import { iconStates, specialIcons } from '../../core/pixi/icons';
import { Container } from './Container';
import { Spine } from './Spine';

export const iconStateAnimations = {
  [iconStates.win]: 'win',
  [iconStates.idle]: 'idle',
  [iconStates.spin]: 'blur',
  [iconStates.noWin]: 'noWin',
  [iconStates.idleBigUp]: 'idleBigUp',
  [iconStates.idleBigDw]: 'idleBigDw',
  [iconStates.idleSmallDw]: 'idleSmallDw',
  [iconStates.idleSmallUp]: 'idleSmallUp',
  [iconStates.idleBigCenter]: 'idleBigCenter',
  [iconStates.idleSmallCenter]: 'idleSmallCenter',
};
// export const animationSpeeds = {
//   [iconStates.idle]: 0,
//   [iconStates.win]: 0.4,
//   [iconStates.spin]: 0,
//   [iconStates.noWin]: 0,
// };

export class SlotIcon extends Container {
  constructor(options) {
    super(options);
    const styles = { origin: 0.5, roundPixels: false };
    this.winParent = options.winParent;
    this.spinParent = this.parent;
    this.icon = this.addChild(
      new Spine({
        elementId: `${this.elementId}_Icon`,
        key: '1',
        styles,
      })
    );
    this.iconNumber = 1;
    this.loop = false;
    this.currentState = null;
    this.changeState(iconStates.idle);
    this.roundPixels = false;
    this.children.forEach((c) => {
      c.roundPixels = false;
    });
  }

  changeIcon(newNumber, state = iconStates.idle) {
    if (newNumber === this.iconNumber) return;
    this.iconNumber = newNumber;
    this.icon.show();
    this.icon.changeTexture(this.iconNumber.toString());
    this.changeState(state);
  }

  changeState(state /* startFrame = 0 */) {
    this.currentState = state;
    this.icon.stop();
    this.changeToActualParent();
    if (this.icon) {
      this.icon.play(iconStateAnimations[state], state === iconStates.win);
      this.icon.clearListeners();
      return new Promise((r) => {
        this.icon.addListener('complete', r);
      });
    }
    return false;
  }

  addOnCompleteHandler(handler, context = null, once = false) {
    if (this.icon) {
      this.icon.addListener('complete', handler, context);
      const spine = this.icon;
      return () => {
        spine.removeListener('complete', handler, context);
      };
    }
    const hh = this.icon.loop ? 'onLoop' : 'onComplete';
    if (this.iconNumber === specialIcons.emptyIcon) {
      handler.call(context);
      // addToGameTimer(100, handler, context);
    } else {
      const a = once
        ? () => {
            handler.call(context);
            this.icon[hh] = null;
          }
        : () => {
            handler.call(context);
          };
      this.icon[hh] = a;
    }
    return () => {
      this.icon[hh] = null;
    };
  }

  changeToActualParent() {
    let parent;
    if (this.currentState === iconStates.win) parent = this.winParent;
    else parent = this.spinParent;
    if (parent !== this.parent) parent.addChild(this);
  }
}

export function getIconValueFromIconNumber(iconNumber) {
  return Number(iconNumber.toString().split('-')[1] || 0);
}
